import React, { useState } from "react";
import LeaveTypes from "./LeaveTypes";
import LeaveRecords from "./LeaveRecords";
import UserLeaves from "./UserLeaves";
import "./LeaveManagement.css";

export default function LeaveManagement() {
  const [activeTab, setActiveTab] = useState("userLeaves");

  const renderTabContent = () => {
    switch (activeTab) {
      case "userLeaves":
        return <UserLeaves />;
      case "leaveRecords":
        return <LeaveRecords />;
      case "leaveTypes":
        return <LeaveTypes />;
      default:
        return null;
    }
  };

  return (
    <div className="leave-management-page">
      <h1>Leave Management</h1>
      <div className="tab-buttons">
        <button
          className={`tab-button ${activeTab === "userLeaves" ? "active" : ""}`}
          onClick={() => setActiveTab("userLeaves")}
        >
          User Leaves
        </button>
        <button
          className={`tab-button ${activeTab === "leaveRecords" ? "active" : ""}`}
          onClick={() => setActiveTab("leaveRecords")}
        >
          Leave Records
        </button>
        <button
          className={`tab-button ${activeTab === "leaveTypes" ? "active" : ""}`}
          onClick={() => setActiveTab("leaveTypes")}
        >
          Leave Types
        </button>
      </div>
      <div className="tab-panel">{renderTabContent()}</div>
    </div>
  );
}
